import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ControllerContext from '../../../RoomControllerSocketContext';
import { toast } from 'react-toastify';

const ConnectYourRoom = () =>
{
	const history = useHistory();
	const { pluginSocket } = useContext(ControllerContext);

	const handleopenconference = () =>
	{
		history.push('/desktop_room');
	};

	useEffect(() =>
	{
		pluginSocket?.on('unpair', async (data) =>
		{
			console.log('unpair called in after pairing==');

			const unpairStatus = await window?.electron?.ipcRenderer?.invoke('unpair');

			console.log('unpair status===', unpairStatus);
			if (unpairStatus)
			{
				toast.dismiss();
				toast.error('Controller Unpaired!');
				pluginSocket.emit('leaveRoom');
				setTimeout(() =>
				{
					// window.location.reload();
					history.push('/');
				}, 2000);
			}
		});
		pluginSocket?.on('receiveToken', (data) =>
		{
			console.log('toke received====', data);
			if (data?.token && data?.roomName && data?.roomId)
			{
				window?.electron?.ipcRenderer.sendMessage('storeData', { key: 'token', value: data.token });
				window?.electron?.ipcRenderer.sendMessage('storeData', { key: 'roomName', value: data.roomName });
				window?.electron?.ipcRenderer.sendMessage('storeData', { key: 'roomId', value: data.roomId });
				pluginSocket?.emit('tokenStatus', { status: true });
				history.push('/desktop_room');
			}
			else
			{
				pluginSocket?.emit('tokenStatus', { status: false, data: 'Invalid Data!' });
			}
		});

		return () =>
		{
			pluginSocket?.off('receiveToken');
			pluginSocket?.off('tokenStatus');
			pluginSocket?.off('unpair');
		};
	}, [ pluginSocket ]);

	const instructions = [
		{
			instruct : 'To link the room you\'ve set up in your InMeet account with this room display, kindly proceed with the following instructions'
		},
		{
			instruct : 'Sign in to your account using a web browser or the desktop app'

		},
		{
			instruct : 'Go to the "Rooms" section within the room management area'
		},
		{
			instruct : 'Use the controller to scan the QR code or input the 6-digit activation key along with the password for the room you wish to connect.'
		}
	];

	return (
		<>
			<div className='flexCol pdngTLG jCntr roomWidth '>
				<div className='flexRow'>
					{/*  onClick={handleopenconference} */}
					<span className='cnnctRoom'>Connect your room</span>
				</div>
				<div className='flexCol pdngXS'>
					<ul className='ulTag'>
						{instructions.map((data, index) => (
							<li key={index} className='liTag'>
								<div className='flexRow pdngXS'>
									<span className='instructions'>{data?.instruct}</span>
								</div>
							</li>))}
					</ul>
				</div>
			</div>
		</>
	);
};

export default ConnectYourRoom;